import { CadWorkerClient } from "../../cad/worker/CadWorkerClient"
import { createLogger } from "../../utils/logger"

const logger = createLogger('process-subdivisions.service')

/**
 * Procesa el cadJson original con el worker para generar las subdivisiones EPC
 * (pilings, modules, panels, axles) según la configuración del modal Configurar.
 *
 * Cada invocación crea su propia instancia del worker y la destruye al terminar,
 * así no hay estado compartido entre llamadas.
 *
 * @param {Object} opts
 * @param {Object} opts.cadJson          - cadJson original parseado del DXF
 * @param {Array}  opts.layers           - descriptores de _GetLayers() / getLayerDescriptors
 * @param {Object} opts.cadLayeredDesign - config (default + por capa) del modal Configurar
 * @returns {Promise<{ totalEntitiesDesign, processedCadJson }>}
 *          totalEntitiesDesign: { pilings, modules, panels } totales generados
 *          processedCadJson:    cadJson mutado con las nuevas entidades y layers EPC
 * @throws {Error} Si el worker falla.
 */
export async function processSubdivisions({ cadJson, layers, cadLayeredDesign, onProgress }) {
  const worker = new CadWorkerClient()
  try {
    const result = await worker.CreateEntities(cadJson, layers, cadLayeredDesign, onProgress)
    logger.info('processed — totals:', result.totalDesign)

    // FIX: congela el dxf antes de devolverlo. Vue 2 saltará la observación
    // recursiva de un objeto con cientos de miles de entidades anidadas, lo cual
    // bloqueaba el main thread minutos antes de propagar el cambio del prop.
    Object.freeze(result.dxf)

    return {
      totalEntitiesDesign: result.totalDesign,
      processedCadJson:    result.dxf,
    }
  } catch (err) {
    logger.error('worker failed:', err)
    throw err
  } finally {
    await worker.Destroy()
  }
}
